// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"22303128","453":"92ee6b61"}[chunkId] + ".chunk.js";
};